{
  "components": {
    "organizationSubAudit": {
      "title": "Sub-Audits",
      "searchPlaceholder": "Find by name, number or owner..",
      "createSubAudit": "Create SubAudit",
      "subAudit": "SubAudit-{{subAuditId}}",
      "emptyListMessage": "It looks like you don't have any subAudits in this section yet.",
      "emptyListMessageWithSearch": "There are no results for the phrase you are looking for. Please use another phrase and try again",
      "sortBy": {
        "title": "Sort by:",
        "options": {
          "status": "Status"
        }
      },
      "status": {
        "new": "New",
        "info": "Gather Info - Vendor",
        "negotiation": "Negotiation in Progress",
        "negotiationComplete": "Negotiation Complete",
        "onHold": "On Hold"
      }
    },
    "subAuditForm": {
      "title": "SubAudit",
      "submitButton": {
        "create": "Create SubAudit",
        "edit": "Save"
      },
      "changeLog": {
        "subAuditCreated": {
          "subAuditWas": "SubAudit was ",
          "created": "created"
        },
        "task": {
          "created": "Task <strong>{{name}}</strong> was created by {{author}}",
          "updated": "Task <strong>{{name}}</strong> was updated by {{author}}",
          "deleted": "Task <strong>{{name}}</strong> was deleted"
        },
        "comment": {
          "added": "Comment <strong>{{name}}</strong> was added by {{author}}"
        },
        "actions": {
          "updated": "updated from",
          "changed": "changed: from {{previousValue}} to",
          "to": "to"
        },
        "fields": {
          "audit": "Audit",
          "owner": "Owner",
          "organization": "Organization",
          "vendor": "Vendor",
          "vendorAccountNumber": "Vendor Account #",
          "spendAmount": "Spend",
          "subauditStage": "SubAudit Stage",
          "updatedBy": "Updated by",
          "createdBy": "Owner",
          "teams": "Teams",
          "subauditName": "SubAudit Name",
          "location": "Location",
          "autoIncrementedId": "SubAudit ID",
          "onHold": "On Hold"
        }
      },
      "sections": {
        "details": {
          "title": "SubAudit details",
          "fields": {
            "subAuditName": {
              "label": "SubAudit Name",
              "placeholder": "SubAudit name..."
            },
            "createdDate": "Created date",
            "owner": "Owner",
            "organization": {
              "label": "Organization",
              "searchPlaceholder": "Find organization..."
            },
            "audit": {
              "label": "Audit",
              "searchPlaceholder": "Find audit..."
            },
            "vendor": {
              "label": "Vendor",
              "searchPlaceholder": "Find vendor..."
            },
            "vendorAccount": {
              "label": "Vendor Account #",
              "primary": "Primary Account #",
              "other": "Other Account #"
            },
            "spend": {
              "label": "Spend",
              "placeholder": "Spend amount..."
            },
            "team": {
              "label": "Team",
              "searchPlaceholder": "Find team..."
            },
            "localization": {
              "label": "Location",
              "searchPlaceholder": "Find location..."
            }
          }
        },
        "status": {
          "title": "Status",
          "fields": {
            "stage": {
              "label": "SubAudit Stage",
              "options": {
                "new": "New",
                "info": "Gather Info - Vendor",
                "negotiation": "Negotiation in Progress",
                "negotiationComplete": "Negotiation Complete",
                "onHold": "On Hold"
              },
              "onHoldConfirm": {
                "title": "On Hold Stage",
                "fields": {
                  "dueDate": {
                    "label": "Due date",
                    "placeholder": "Select due date..."
                  },
                  "reason": {
                    "label": "Reason",
                    "placeholder": "Reason..."
                  }
                },
                "submitButton": "Set To On Hold"
              }
            },
            "onHold": {
              "label": "(On Hold)"
            },
            "changeHistory": {
              "title": "Change history",
              "emptyMessage": "There is no change history for this SubAudit yet."
            },
            "comments": {
              "title": "Comments",
              "emptyMessage": "There are no comments yet.",
              "commentForm": {
                "title": "Add comment",
                "topic": {
                  "label": "Topic",
                  "placeholder": "Comment topic..."
                },
                "comment": {
                  "label": "Comment",
                  "placeholder": "Write a comment..."
                },
                "submitText": "Save"
              },
              "button": "Add comment"
            },
            "relatedTasks": {
              "title": "Related tasks",
              "emptyMessage": "There are no related tasks yet.",
              "button": "Create related task"
            },
            "meetingDate": "Meeting date"
          }
        }
      }
    },
    "auditDetailsHeader": {
      "title": "Edit audit",
      "breadcrumb": {
        "audits": "Audits"
      },
      "actions": {
        "createFollowUpAudit": "Create follow-up audit"
      },
      "error": {
        "title": "Failed to load audit"
      }
    },
    "auditDetails": {
      "basicInfo": {
        "spendArea": "Spend area",
        "spendCategory": "Spend category",
        "vendor": "Vendor",
        "contractTerms": "SIB Contract Terms",
        "dueDate": "Due date",
        "created": "Created",
        "creator": "Creator",
        "status": "Status"
      },
      "saveInfo": {
        "title": "No need to save - all changes are saved automatically"
      },
      "editForm": {
        "auditName": "Audit name",
        "status": "Status",
        "team": "Team",
        "owner": "Owner",
        "dueDate": "Due date"
      },
      "stageProgress": {
        "dialog": {
          "title": "Moving to next stage of audit",
          "description": "You are moving to the next audit stage. Once you continue, you will no longer be able to make changes to this stage. Please review all information carefully before proceeding. You will still be able to view previous stages by clicking their names."
        }
      },
      "tabs": {
        "spendSavings": "Spend & Savings",
        "vendorContacts": "Vendor contacts",
        "managingLocations": "Managing locations",
        "documents": "Documents",
        "vendorAccount": "Vendor account",
        "vendorArchivePocs": "Vendor archive POCs",
        "linkedAudits": "Linked audits",
        "activityHistory": "Activity history",
        "comments": "Comments"
      },
      "uploadDocuments": {
        "informationMessage": "Please note that all uploaded documents will be available in the Organization’s main Documents Repository. You can attach or detach documents from an audit at any time without deleting them from the main Repository.",
        "title": "Upload or attach documents",
        "dropzoneTitle": "Drag and drop files here or use the buttons below",
        "dropzoneDescription": "Add new documents by uploading new files or attaching existing ones from the Documents Repository. All files uploaded from your computer will also be available in the Documents Repository. Supported formats: PDF, DOC, DOCX, JPG, XLSX",
        "attachFromRepository": "Attach from documents repository",
        "uploadFromComputer": "Upload from computer",
        "documentsRepository": {
          "title": "Documents repository",
          "informationMessage": "Assign documents from the Organization's Document Repository to this audit or detach them as needed. Please note that documents stored in the Organization's Document Repository cannot be edited or deleted from here. To modify a document, go to the Organization's main Document Repository.",
          "actions": {
            "attachToAudit": {
              "label": "Attach to audit",
              "ariaLabel": "Attach document to audit"
            },
            "detachFromAudit": {
              "label": "Detach from audit",
              "ariaLabel": "Detach document from this audit",
              "tooltip": "Detach document from this audit"
            },
            "displayOnlyAttached": "Display only attached documents",
            "attachedCount": "{{count}} documents attached to this audit",
            "delete": {
              "ariaLabel": "Delete document"
            },
            "attachedIndicator": {
              "ariaLabel": "Document attached to this audit",
              "tooltip": "Document attached to this audit"
            },
            "attach": {
              "success_one": "Document attached to audit successfully",
              "success_other": "{{count}} documents attached to audit successfully",
              "error": "Failed to attach document(s) to audit. Please try again."
            },
            "detach": {
              "success_one": "Document detached from audit successfully",
              "success_other": "{{count}} documents detached from audit successfully",
              "error": "Failed to detach document(s) from audit. Please try again."
            },
            "tooltips": {
              "bulkAttachDisabledAlreadyAttached": "One or more selected documents are already attached to this audit.",
              "bulkDetachDisabledNotAttached": "One or more selected documents are not attached to this audit."
            }
          },
          "table": {
            "columns": {
              "uploadedAuditStage": "Uploaded audit stage",
              "attachedToThisAudit": "Attached to this audit"
            }
          },
          "noData": {
            "title": "No documents found",
            "description": "No documents match the current filters."
          }
        }
      },
      "attachedDocuments": {
        "title": "Documents attached to this audit ({{count}})",
        "detach": "Detach",
        "detachDialog": {
          "title": "Are you sure you want to detach this document from this audit?",
          "description": "This document will no longer be associated with this audit. However, it will remain available in the organization's main Documents Repository and can be linked to audits again in the future."
        },
        "deleteDialog": {
          "title": "Are you sure you want to delete files?",
          "description": "Deleting files will also remove them from the main Documents Repository. You can attach or detach documents from an audit at any time without deleting them from the main Repository."
        },
        "actions": {
          "detach": {
            "ariaLabel": "Detach document from audit",
            "success": "Document(s) detached from audit successfully",
            "error": "Failed to detach document(s) from audit. Please try again."
          },
          "delete": {
            "ariaLabel": "Delete document",
            "success": "Document(s) deleted successfully",
            "error": "Failed to delete document(s). Please try again."
          },
          "editAriaLabel": "Edit document",
          "tooltips": {
            "bulkDetachDisabled": "Detach document(s) from this audit. They will no longer be associated with this audit but will still be available in the organization's main Documents Repository.",
            "bulkDeleteDisabled": "Delete documents. Please note deleted documents will also be removed from the organization's main Documents Repository.",
            "bulkEditUploadedDocumentsOnlyDisabled": "Bulk edit is available only for uploaded documents.",
            "bulkDeleteUploadedDocumentsOnlyDisabled": "Bulk delete is available only for uploaded documents.",
            "rowDetach": "Detach document from this audit. It will no longer be associated with this audit but will still be available in the organization's main Documents Repository.",
            "rowDelete": "Delete document. Please note deleted documents will also be removed from the organization's main Documents Repository.",
            "rowEditDisabled": "This document is attached from the main organization's Document Repository and cannot be edited here. To edit this document, please go to the main Document Repository.",
            "rowDeleteDisabled": "This document is attached from the main organization's Document Repository and cannot be deleted here. To delete this document, please go to the main Document Repository."
          }
        },
        "table": {
          "columns": {
            "annualContractValue": "Annual contract value",
            "nte": "NTE",
            "api": "API",
            "etf": "ETF",
            "startDate": "Start date",
            "endDate": "End date",
            "sensitive": "Sensitive"
          }
        },
        "noData": {
          "title": "No documents attached",
          "description": "Upload or attach documents to see them listed here."
        }
      },
      "vendorAccounts": {
        "title": "Vendor accounts",
        "description": "Enter the client's account number exactly as it appears on vendor invoices. This information is required to generate the Vendor Savings Report (VSR). Newly created vendor accounts will also be added to the organization's main vendor account list.",
        "actions": {
          "addNewAccount": "Add new account",
          "addNewAccountDisabled": "Cannot add account — audit is missing vendor or spend category.",
          "attachFromExistingList": "Attach from existing list",
          "details": "Details",
          "detailsTooltip": "This vendor account was attached from the organization's main Vendor Accounts list and cannot be edited here. You can still view its details. To edit this account, please go to the main Vendor Accounts list.",
          "edit": "Edit",
          "detach": "Detach",
          "detachTooltip": "Detach this vendor account from the audit. It will no longer be associated with this audit but will remain available in the organization's main Vendor Accounts list."
        },
        "form": {
          "addTitle": "Add new vendor account",
          "editTitle": "Edit vendor account",
          "detailsTitle": "Vendor account details",
          "infoBanner": "Please note that newly created vendor accounts will be tied to audit's selected vendor and spend category and will be also automatically created in organization's main vendor account list. The account number status is set to Active by default. You can change it later by editing the vendor account.",
          "accountNumberHelper": "Required for VSR",
          "vendorTooltip": "You cannot edit the vendor for this vendor account. It is automatically assigned from the audit.",
          "spendCategoriesTooltip": "Spend categories are inherited from the audit vendor and cannot be changed here.",
          "notifications": {
            "createSuccess": "Vendor account created and attached to audit successfully",
            "createError": "Failed to create vendor account",
            "attachError": "Vendor account was created but failed to attach to audit. You can attach it from the existing list.",
            "updateSuccess": "Vendor account updated successfully",
            "updateError": "Failed to update vendor account"
          }
        },
        "emptyState": {
          "title": "No vendor accounts assigned or created yet",
          "description": "Add a new vendor account or attach one from the organization's existing vendor account list"
        },
        "fields": {
          "accountNumber": "Account number",
          "accountName": "Account name",
          "vendor": "Vendor",
          "status": "Status",
          "spendCategories": "Spend categories ({{count}})",
          "locations": "Locations",
          "notes": "Notes"
        },
        "detachDialog": {
          "title": "Are you sure you want to detach this vendor account from this audit?",
          "description": "This vendor account will no longer be associated with this audit. However, it will remain available in the organization's main vendor account list and can be linked to audits again in the future."
        },
        "statusChangeDialog": {
          "activate": {
            "title": "Activating vendor account",
            "description": "You've changed the status of the vendor account to Active. Are you sure you want to activate this vendor account?",
            "confirm": "Activate"
          },
          "deactivate": {
            "title": "Deactivating vendor account",
            "description": "You've changed the status of the vendor account to Inactive. Are you sure you want to deactivate this vendor account?",
            "confirm": "Deactivate"
          }
        },
        "detach": {
          "success": "Vendor account(s) detached from audit successfully",
          "error": "Failed to detach vendor account(s) from audit. Please try again."
        },
        "repository": {
          "title": "Vendor accounts",
          "informationMessage": "You are currently viewing only vendor accounts associated with this audit's vendor and spend category (Spend Category: <strong>{{spendCategoryName}}</strong>). To see all vendor accounts, go to the organization's Vendor Accounts list.",
          "informationMessageWithVendor": "You are currently viewing only vendor accounts associated with this audit's vendor and spend category (Vendor: <strong>{{vendorName}}</strong> & Spend Category: <strong>{{spendCategoryName}}</strong>). To see all vendor accounts, go to the organization's Vendor Accounts list.",
          "actions": {
            "attachToAudit": {
              "label": "Attach to audit",
              "ariaLabel": "Attach vendor account to audit"
            },
            "detachFromAudit": {
              "label": "Detach from audit",
              "ariaLabel": "Detach vendor account from this audit",
              "tooltip": "Detach vendor account from this audit"
            },
            "displayOnlyAttached": "Display only attached accounts",
            "attachedCount": "{{count}} vendor accounts attached to this audit",
            "attachedIndicator": {
              "ariaLabel": "Vendor account attached to this audit",
              "tooltip": "Vendor account attached to this audit"
            },
            "attach": {
              "success_one": "Vendor account attached to audit successfully",
              "success_other": "{{count}} vendor accounts attached to audit successfully",
              "error": "Failed to attach vendor account(s) to audit. Please try again."
            },
            "detach": {
              "success_one": "Vendor account detached from audit successfully",
              "success_other": "{{count}} vendor accounts detached from audit successfully",
              "error": "Failed to detach vendor account(s) from audit. Please try again."
            },
            "tooltips": {
              "bulkAttachDisabledAlreadyAttached": "One or more selected vendor accounts are already attached to this audit.",
              "bulkDetachDisabledNotAttached": "One or more selected vendor accounts are not attached to this audit."
            }
          },
          "table": {
            "columns": {
              "vendorAccountName": "Vendor account name",
              "assignedAudits": "Assigned audits"
            }
          },
          "noData": {
            "title": "No vendor accounts found",
            "description": "No vendor accounts match the current filters."
          }
        }
      },
      "comments": {
        "title": "Comments ({{count}})",
        "description": "Add comments to this audit about topics you would like other SIB employees to be aware of, such as important decisions or unusual circumstances. You can also tag a recipient, who will be automatically assigned to the note. \nWould you like to create a ticket automatically from this comment?",
        "actions": {
          "addNew": "Add new"
        },
        "emptyState": {
          "title": "It looks like there are no comments added for this audit yet",
          "description": "Create your first comment by clicking \"Add new\" button"
        },
        "filters": {
          "commentNote": "Comment",
          "ownerAssignee": "Owner / assignee",
          "creator": "Creator",
          "created": "Created",
          "createdInAuditStage": "Created in audit stage"
        },
        "tile": {
          "subject": "Subject",
          "creator": "Creator",
          "created": "Created",
          "createdInAuditStage": "Created in audit stage",
          "ownerAssignee": "Owner / assignee",
          "commentNote": "Comment",
          "delete": "Delete",
          "deleteDisabledTooltip": "You can only delete comments you created",
          "seeMore": "see more",
          "seeLess": "see less"
        },
        "deleteDialog": {
          "title": "Delete comment",
          "description": "Are you sure you want to delete this comment? This action cannot be undone."
        },
        "notifications": {
          "deleteSuccess": "Comment deleted successfully",
          "deleteError": "Failed to delete comment"
        },
        "form": {
          "title": "Add new comment",
          "fields": {
            "subject": "Subject",
            "ownerAssignee": "Owner / assignee",
            "commentNote": "Comment",
            "autoCreateTask": "Automatically create a task for the assignee / owner"
          },
          "autoTaskDefaultTitle": "Follow up on comment",
          "autoCreateTaskDisabledTooltip": "Select an owner / assignee to enable automatic task creation",
          "notifications": {
            "createSuccess": "Comment created successfully",
            "createError": "Failed to create comment",
            "createTaskSuccess": "Task created successfully",
            "createTaskError": "Failed to create task"
          }
        }
      },
      "spendEstimated": {
        "title": "Import spend items",
        "description": "Import spend items from a template, create them manually, or use spend items from an existing audit.",
        "actions": {
          "addSpend": "Add item",
          "downloadTemplate": "Template",
          "uploadSpend": "Import items",
          "attachFromExistingAudit": "Attach spend items from existing audit"
        },
        "upload": {
          "dialogTitle": "Upload spend estimated file",
          "fileLabel": "Spend estimated file",
          "success": "Spends imported successfully",
          "invalidRows": "{{count}} row(s) failed validation. Please fix the file and try again.",
          "duplicatesSkipped": "{{count}} duplicate spend item(s) were skipped.",
          "missingLocationInfo": "Some imported rows are missing a location number. You can add locations later."
        },
        "totals": {
          "auditTotal": "Total"
        },
        "locationGroups": {
          "organizationWide": "Organization-wide"
        },
        "spend": {
          "edit": "Edit spend",
          "delete": "Delete spend",
          "form": {
            "titleCreate": "Add new item",
            "titleEdit": "Edit item",
            "successCreate": "Spend created successfully",
            "successEdit": "Spend updated successfully",
            "successBulkEdit": "Spends updated successfully",
            "errorBulkEdit": "Failed to update selected spends",
            "fields": {
              "name": "Name",
              "vendorAccountNumber": "Vendor account number",
              "unit": "Unit",
              "quantity": "Quantity",
              "pricePerUnit": "Price per unit",
              "occurrenceInterval": "Occurrence interval",
              "location": "Location",
              "locationHelper": "Leave as organization-wide when the spend applies to the whole organization.",
              "occurrenceIntervalOptions": {
                "monthly": "Monthly",
                "quarterly": "Quarterly",
                "yearly": "Yearly",
                "oneTime": "One-time"
              }
            }
          },
          "deleteDialog": {
            "title": "Delete spend",
            "bulkTitle": "Delete spends",
            "description": "This will permanently remove this spend from the audit.",
            "bulkDescription": "This will permanently remove {{count}} spends from the audit.",
            "success_one": "Spend deleted successfully",
            "success_other": "{{count}} spends deleted successfully"
          }
        },
        "table": {
          "columns": {
            "name": "Name",
            "vendorAccountNumber": "Vendor account number",
            "unit": "Unit",
            "quantity": "Qty",
            "pricePerUnit": "Cost",
            "total": "Total",
            "occurrenceInterval": "Occurrence interval",
            "locationName": "Location"
          }
        },
        "emptyState": {
          "title": "No spends imported yet",
          "description": "Download the template, fill it with spend data, and upload it to view estimated spend for this audit."
        }
      },
      "negotiations": {
        "kpis": {
          "baselineSpend": "Baseline spend",
          "proposedSpend": "Proposed spend",
          "savingsIdentified": "Savings identified",
          "spendItemsCount": "No of spend items",
          "lockedAtAuditLevel": "locked at audit level",
          "savingsPercentage": "({{percentage}} %)"
        },
        "continueDialog": {
          "notApproved": {
            "title": "Some of items are not approved",
            "description": "Only {{approved}} out of {{total}} spend items are approved. {{rejected}} items will be marked as rejected and cannot be approved later on. Are you sure you want to move to the next audit stage? Once completing this step you can display it only."
          },
          "missingSpend": {
            "title": "Some items do not have a proposed spend value assigned",
            "description": "They will be marked as approved but will show 0% savings in subsequent stages."
          },
          "negativeSavings": {
            "title": "Negative savings detected",
            "description": "For some items, the proposed spend is higher than the baseline spend, which means the savings will be negative."
          },
          "notApprovedAndMissing": {
            "title": "Some of items are not approved or do not have a proposed spend value assigned",
            "description": "Only {{approved}} out of {{total}} spend items are approved and {{missing}} of them has no proposed spend value assigned. {{rejected}} items will be marked as rejected and cannot be approved later on. Are you sure you want to move to the next audit stage? Once completing this step you can display it only."
          },
          "notApprovedAndNegative": {
            "title": "Some of items are not approved or has negative spend detected",
            "description": "Only {{approved}} out of {{total}} spend items are approved. {{rejected}} items will be marked as rejected and cannot be approved later on. Are you sure you want to move to the next audit stage? Once completing this step you can display it only."
          },
          "missingAndNegative": {
            "title": "Some items do not have a proposed spend value assigned or has negative spend detected",
            "description": "They will be marked as approved but will show 0% savings in subsequent stages. For some items, the proposed spend is higher than the baseline spend, which means the savings will be negative."
          },
          "all": {
            "title": "Some of items are not approved, do not have a proposed spend value assigned or has negative spend detected",
            "description": "Only {{approved}} out of {{total}} spend items are approved and {{missing}} of them has no proposed spend value assigned. {{rejected}} items will be marked as rejected and cannot be approved later on. Are you sure you want to move to the next audit stage? Once completing this step you can display it only."
          },
          "approvedSpendItemsLabel": "No of approved spend items",
          "approvedWithoutProposedSpendLabel": "No of approved items without any proposed spend assigned",
          "itemsWithoutProposedSpendLabel": "No of items you want to approve without any proposed spend assigned",
          "negativeSavingsItemsLabel": "No of spend items with negative savings detected",
          "savingsPercentage": "{{percentage}} % savings"
        },
        "vendors": {
          "title": "Vendor",
          "description": "At this stage, you are negotiating the spend with the vendor. If the baseline vendor does not meet your expectations, you can add a new vendor to the audit and negotiate a better proposed spend with them. If you add a new vendor, don't forget to assign them to the items being negotiated.",
          "baselineSpendVendor": "Baseline spend vendor",
          "proposedVendor": "Proposed vendor",
          "deleteTooltip": "You can delete this vendor as it was created in this audit. It will disappear from main vendors list as well.",
          "addNewTooltip": "You can create a new vendor (it will be automatically added to the vendor list) if the current vendor does not meet your proposed spend expectations.",
          "addNewDisabledTooltip": "A proposed vendor is already attached to this audit. Detach it before adding a new one.",
          "deleteDialog": {
            "withApprovedSpendItems": {
              "title": "Deleting a vendor with approved spend items",
              "description": "You are about to delete a vendor that is assigned to approved spend items. The vendor will also disappear from the main vendor list. All affected items will be automatically reassigned to the baseline vendor and marked as not approved. Do you want to continue?"
            },
            "withoutApprovedSpendItems": {
              "title": "Deleting vendor",
              "description": "You are about to delete a vendor. The vendor will also disappear from the main vendor list. All affected spend items will be automatically reassigned to the baseline vendor. Do you want to continue?"
            }
          },
          "delete": {
            "success": "Vendor deleted successfully",
            "error": "Failed to delete vendor. Please try again."
          },
          "actions": {
            "addNew": "Add new",
            "attachToAudit": "Attach to audit"
          },
          "fields": {
            "baselineSpend": "Baseline spend",
            "proposedSpend": "Proposed spend",
            "savingsIdentified": "Savings identified",
            "approvedSpendItems": "No of approved spend items",
            "savingsPercentage": "({{percentage}}%)",
            "approvedSpendItemsValue": "{{approved}} / {{total}}"
          },
          "addModal": {
            "title": "Add new proposed vendor",
            "notice": "Please note that this vendor will also be added to the main vendor list.",
            "createSuccess": "Vendor created and attached to audit successfully"
          },
          "detachDialog": {
            "withApprovedSpendItems": {
              "title": "Detaching a vendor with approved spend items from the audit",
              "description": "You are about to detach a vendor that is assigned to approved spend items. All affected items will be automatically reassigned to the baseline vendor (or to the newly attached vendor, if provided) and marked as not approved. Do you want to continue?"
            },
            "withoutApprovedSpendItems": {
              "title": "Detaching a proposed vendor from the audit",
              "description": "You are about to detach a vendor that is assigned to all spend items. These spend items will be automatically reassigned to the baseline vendor (or to the newly attached vendor, if one is provided later). Do you want to continue?"
            }
          },
          "attachDialog": {
            "withApprovedSpendItems": {
              "title": "Attaching a new vendor will automatically assign it to all items and mark them as “Not Approved”",
              "description": "Some spend items have already been approved for the proposed vendor. Attaching a new vendor will automatically reassign these items to the new vendor, and they will no longer be marked as approved. Please make sure to approve them again."
            }
          },
          "createDialog": {
            "withApprovedSpendItems": {
              "title": "Creating a new vendor will automatically assign it to all items and mark them as “Not Approved”",
              "description": "Some spend items have already been approved for the proposed vendor. Creating a new vendor will automatically reassign these items to the new vendor, and they will no longer be marked as approved. Please make sure to approve them again."
            }
          }
        },
        "vendorsRepository": {
          "title": "SIB Vendor List",
          "informationMessage": "Select and assign an existing vendor to the audit. You can attach vendors assigned to the audit's spend category.",
          "tempOpenButton": "Open SIB Vendor List (temp)",
          "actions": {
            "attachToAudit": {
              "label": "Attach to audit",
              "ariaLabel": "Attach vendor to audit"
            },
            "detachFromAudit": {
              "label": "Detach from audit",
              "ariaLabel": "Detach vendor from this audit",
              "tooltip": "Detach vendor from this audit"
            },
            "displayVendorsAssignedToOtherCategories": "Display vendors assigned to other categories",
            "attachedCount_one": "{{count}} vendor attached to this audit",
            "attachedCount_other": "{{count}} vendors attached to this audit",
            "attachedIndicator": {
              "ariaLabel": "Vendor attached to this audit",
              "tooltip": "Vendor attached to this audit"
            },
            "attach": {
              "success_one": "Vendor attached to audit successfully",
              "success_other": "{{count}} vendors attached to audit successfully",
              "error": "Failed to attach vendor(s) to audit. Please try again."
            },
            "detach": {
              "success_one": "Vendor detached from audit successfully",
              "success_other": "{{count}} vendors detached from audit successfully",
              "error": "Failed to detach vendor(s) from audit. Please try again."
            },
            "tooltips": {
              "bulkAttachDisabledAlreadyAttached": "One or more selected vendors are already attached to this audit.",
              "bulkDetachDisabledNotAttached": "One or more selected vendors are not attached to this audit."
            }
          },
          "table": {
            "columns": {
              "vendorName": "Vendor Name",
              "category": "Category",
              "spendAreas": "Spend Areas",
              "contracts": "Contracts",
              "clients": "Clients",
              "audits": "Audits",
              "openTickets": "Open tickets"
            },
            "selectVendor": "Select vendor",
            "categoryOverflowTriggerAriaLabel": "Show {{count}} more categories",
            "spendAreasOverflowTriggerAriaLabel": "Show {{count}} more spend areas"
          },
          "noData": {
            "title": "No vendors found",
            "description": "No vendors match the current filters."
          }
        },
        "spendItems": {
          "title": "Negotiate spend items",
          "description": "Set a new proposed spend for the selected items, choose a vendor, and approve them. If you do not approve the items before moving to the next stage, they will be marked as Spend Rejected. Items approved without a proposed spend value will be treated as having 0% savings.",
          "displayNotApprovedOnly": "Display not approved spend only",
          "approveTooltip": "Approve the items after you have finished negotiating with both the vendor and the client. Any items not approved before moving to the next stage will be marked as \"Spend Rejected\". Items approved without a proposed spend value will be treated as having 0% savings.",
          "pricePerUnitApprovedTooltip": "You cannot edit the price per unit on approved items. Revoke approval first to make changes.",
          "quantityApprovedTooltip": "You cannot edit the quantity on approved items. Revoke approval first to make changes.",
          "approve": {
            "success": "Spend item approved",
            "revoked": "Spend item approval revoked"
          },
          "pricePerUnit": {
            "success": "Price per unit updated"
          },
          "quantity": {
            "success": "Quantity updated"
          },
          "bulkApprove": {
            "success_one": "Spend item approved successfully",
            "success_other": "{{count}} spend items approved successfully"
          },
          "columns": {
            "itemId": "Item ID",
            "itemName": "Item name",
            "baselineQuantity": "Baseline quantity",
            "baselinePricePerUnit": "Baseline price per unit",
            "proposedQuantity": "Proposed quantity",
            "proposedPricePerUnit": "Proposed price per unit",
            "baselineSpend": "Baseline spend",
            "proposedSpend": "Proposed spend",
            "savingsIdentified": "Savings identified",
            "proposedVendor": "Proposed vendor"
          },
          "emptyState": {
            "title": "No spend items",
            "description": "There are no spend items to negotiate yet."
          }
        }
      }
    }
  }
}
